import { useEffect, useState, useRef } from "react";
import Webcam from "react-webcam";
import { useParams, useNavigate } from "react-router-dom";
import { getPlans } from "../../services/membershipService";

import DashboardLayout from "../../layouts/DashboardLayout";

import { getMemberById, updateMember } from "../../services/memberService";

import { getTrainers } from "../../services/trainerService";
import { getWorkoutPlans } from "../../services/workoutPlanService";
import { getDietPlans } from "../../services/dietPlanService";
import { getGymByUserId } from "../../services/gymService";
import { auth } from "../../firebase/config";
import { storage } from "../../firebase/config";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";

import "./AddMember.css";

export default function EditMember() {
  const { id } = useParams();

  const navigate = useNavigate();

  const [trainers, setTrainers] = useState([]);
  const [plans, setPlans] = useState([]);
  const [photo, setPhoto] = useState("");
  const [workoutPlans, setWorkoutPlans] = useState([]);
  const [dietPlans, setDietPlans] = useState([]);
  const [gym, setGym] = useState(null);

  const webcamRef = useRef(null);
  const [showCamera, setShowCamera] = useState(false);
  const [formData, setFormData] = useState({
    memberId: "",
    fullName: "",
    phone: "",
    email: "",
    membershipPlan: "Basic",
    joinDate: "",
    expiryDate: "",
    trainerName: "",
    workoutPlanId: "",
    dietPlanId: "",
    status: "Active",
    photo: "",
    photoPath: "",
    photoBase64: "",
  });

  useEffect(() => {
    loadMember();
    loadTrainers();
    loadPlans();
    loadWorkoutPlans();
    loadDietPlans();
    loadGym();
  }, []);

  const fileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = () => resolve(reader.result);

      reader.onerror = reject;

      reader.readAsDataURL(file);
    });
  };

  const loadGym = async () => {
    try {
      const data = await getGymByUserId(auth.currentUser.uid);
      setGym(data);
    } catch (error) {
      console.error(error);
    }
  };
  const loadMember = async () => {
    try {
      const member = await getMemberById(id);

      setFormData({
        memberId: member.memberId || "",
        fullName: member.fullName || "",
        phone: member.phone || "",
        email: member.email || "",
        membershipPlan: member.membershipPlan || "Basic",
        joinDate: member.joinDate || "",
        expiryDate: member.expiryDate || "",
        trainerName: member.trainerName || "",
        workoutPlanId: member.workoutPlanId || "",
        dietPlanId: member.dietPlanId || "",
        status: member.status || "Active",

        photo: member.photo || "",
        photoPath: member.photoPath || "",
        photoBase64: member.photoBase64 || "",
      });

      setPhoto(member.photo || "");
    } catch (error) {
      console.error(error);
    }
  };

  const loadTrainers = async () => {
    try {
      const data = await getTrainers();

      setTrainers(data);
    } catch (error) {
      console.error(error);
    }
  };

  const loadPlans = async () => {
    try {
      const data = await getPlans();
      setPlans(data);
    } catch (error) {
      console.error(error);
    }
  };

  const loadWorkoutPlans = async () => {
    try {
      const data = await getWorkoutPlans();
      setWorkoutPlans(data);
    } catch (error) {
      console.error(error);
    }
  };

  const loadDietPlans = async () => {
    try {
      const data = await getDietPlans();
      setDietPlans(data);
    } catch (error) {
      console.error(error);
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handlePhotoChange = async (e) => {
    const file = e.target.files[0];

    if (!file) return;

    try {
      const photoPath = `memberPhotos/${auth.currentUser.uid}/${Date.now()}_${file.name}`;

      const storageRef = ref(storage, photoPath);

      await uploadBytes(storageRef, file);

      const downloadURL = await getDownloadURL(storageRef);
      const photoBase64 = await fileToBase64(file);

      setPhoto(downloadURL);

      setFormData((prev) => ({
        ...prev,
        photo: downloadURL,
        photoBase64,
        photoPath,
      }));
    } catch (error) {
      console.error(error);
      alert(error.message);
    }
  };

  const capturePhoto = async () => {
    const imageSrc = webcamRef.current.getScreenshot();

    if (!imageSrc) {
      alert("Failed to capture image.");
      return;
    }

    try {
      // Convert Base64 image to Blob
      const response = await fetch(imageSrc);
      const blob = await response.blob();

      const photoPath = `memberPhotos/${auth.currentUser.uid}/${Date.now()}_camera.jpg`;

      const storageRef = ref(storage, photoPath);

      // Upload to Firebase Storage
      await uploadBytes(storageRef, blob);

      // Get Firebase download URL
      const downloadURL = await getDownloadURL(storageRef);

      // Update preview
      setPhoto(downloadURL);

      // Save URL in form data
      setFormData((prev) => ({
        ...prev,
        photo: downloadURL,
        photoBase64: imageSrc,
        photoPath,
      }));

      setShowCamera(false);

      alert("Photo captured and uploaded successfully.");
    } catch (error) {
      console.error(error);
      alert(error.message);
    }
  };

  const handleSubmit = async () => {
    // Validation
    if (!formData.fullName.trim()) {
      alert("Please enter Full Name");
      return;
    }

    if (!formData.phone.trim()) {
      alert("Please enter Phone Number");
      return;
    }

    if (!/^[6-9]\d{9}$/.test(formData.phone)) {
      alert("Please enter a valid 10-digit Phone Number");
      return;
    }
    if (!formData.email.trim()) {
      alert("Please enter Email");
      return;
    }

    // const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!formData.membershipPlan) {
      alert("Please select Membership Plan");
      return;
    }

    if (!formData.joinDate) {
      alert("Please select Join Date");
      return;
    }

    if (!formData.expiryDate) {
      alert("Please select Expiry Date");
      return;
    }

    if (!formData.trainerName) {
      alert("Please select Trainer");
      return;
    }

    // Only required for Premium plan
    if (gym?.features?.aiWorkout && !formData.workoutPlanId) {
      alert("Please select Workout Plan");
      return;
    }

    // Only required for Premium plan
    if (gym?.features?.dietPlan && !formData.dietPlanId) {
      alert("Please select Diet Plan");
      return;
    }

    if (!formData.photo) {
      alert("Please upload Member Photo");
      return;
    }

    if (!formData.status) {
      alert("Please select Status");
      return;
    }

    try {
      await updateMember(id, formData);

      alert("Member Updated Successfully");

      navigate("/members");
    } catch (error) {
      console.error(error);
      alert("Error Updating Member");
    }
  };

  return (
    <DashboardLayout>
      <div className="member-form-card">
        <h2 className="form-title">Edit Member</h2>

        <div className="form-grid">
          <div className="form-group">
            <label>Member ID</label>

            <input
              type="text"
              value={formData.memberId}
              readOnly
              className="readonly-input"
            />
          </div>
          <div className="form-group">
            <label>Full Name</label>

            <input
              type="text"
              name="fullName"
              value={formData.fullName}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label>Phone Number</label>

            <input
              type="text"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label>Email</label>

            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label>Membership Plan</label>

            <select
              name="membershipPlan"
              value={formData.membershipPlan}
              onChange={handleChange}
            >
              <option value="">Select Membership Plan</option>

              {plans.map((plan) => (
                <option key={plan.id} value={plan.planName}>
                  {plan.planName} - ₹{plan.price}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label>Join Date</label>

            <input
              type="date"
              name="joinDate"
              value={formData.joinDate}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label>Expiry Date</label>

            <input
              type="date"
              name="expiryDate"
              value={formData.expiryDate}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label>Trainer</label>

            <select
              name="trainerName"
              value={formData.trainerName}
              onChange={handleChange}
            >
              <option value="">Select Trainer</option>

              {trainers.map((trainer) => (
                <option key={trainer.id} value={trainer.name}>
                  {trainer.name}
                </option>
              ))}
            </select>
          </div>
          {gym?.features?.aiWorkout && (
            <div className="form-group">
              <label>Workout Plan</label>

              <select
                name="workoutPlanId"
                value={formData.workoutPlanId}
                onChange={handleChange}
              >
                <option value="">Select Workout Plan</option>

                {workoutPlans.map((plan) => (
                  <option key={plan.id} value={plan.id}>
                    {plan.planName}
                  </option>
                ))}
              </select>
            </div>
          )}

          {gym?.features?.dietPlan && (
            <div className="form-group">
              <label>Diet Plan</label>

              <select
                name="dietPlanId"
                value={formData.dietPlanId}
                onChange={handleChange}
              >
                <option value="">Select Diet Plan</option>

                {dietPlans.map((plan) => (
                  <option key={plan.id} value={plan.id}>
                    {plan.planName}
                  </option>
                ))}
              </select>
            </div>
          )}

          <div className="form-group">
            <label>Member Photo</label>

            <div className="photo-upload-options">
              <div className="upload-box">
                <label className="upload-btn">
                  Upload From Device
                  <input
                    type="file"
                    accept="image/*"
                    onChange={handlePhotoChange}
                    hidden
                  />
                </label>
              </div>

              <div className="upload-box">
                <button
                  type="button"
                  className="upload-btn camera-btn"
                  onClick={() => setShowCamera(true)}
                >
                  📷 Capture From Camera
                </button>
              </div>
            </div>
          </div>

          <div className="form-group">
            <label>Status</label>

            <select
              name="status"
              value={formData.status}
              onChange={handleChange}
            >
              <option value="Active">Active</option>

              <option value="Inactive">Inactive</option>

              <option value="Expired">Expired</option>
            </select>
          </div>
        </div>
        {showCamera && (
          <div className="camera-container">
            <Webcam
              audio={false}
              ref={webcamRef}
              screenshotFormat="image/jpeg"
              className="webcam-preview"
            />

            <div className="camera-actions">
              <button
                type="button"
                className="capture-btn"
                onClick={capturePhoto}
              >
                Capture Photo
              </button>

              <button
                type="button"
                className="cancel-btn"
                onClick={() => setShowCamera(false)}
              >
                Cancel
              </button>
            </div>
          </div>
        )}
        {photo && (
          <div className="photo-preview">
            <img src={photo} alt="Member" />
          </div>
        )}
        <button className="save-btn" onClick={handleSubmit}>
          Update Member
        </button>
      </div>
    </DashboardLayout>
  );
}
